<template lang="pug">
  .page-content
    el-row
      el-col(:lg="24" :md="24")
        h1.title Central do Interessado
        br
        el-button.texto-aviso(
          type="text",
          @click="redirect",
        )
          font-awesome-icon.icon-aviso(icon="file")
          | &nbsp Verifique os documentos necessários para fazer o cadastro
        br
        p A
          b  Central do Interessado
          |  {{CENTRAL_DO_INTERESSADO.DESCRICAO}}

        p
          b Central de Mensagens:&nbsp
          | fornece meios para o interessado/cadastrante acompanhar o andamento do seu processo,
          | recebendo notificações sobre possíveis pendências ou esclarecimentos identificados no curso da análise.
        p A Central de Mensagens conta com {{ (isIcmBio() || isRondonia()) ? '4' : '5' }} (cinco) funcionalidades:

        div.funcionalidades
          p 1. Acompanhar processos;
            br
            |  2. Visualizar mensagens;
            br
            |  3. Responder mensagens;
            br
            |  4. Receber por e-mail notificações da existência de mensagens na Central do Interessado;
        div(v-if="!isAmapa() && !isRondonia() && !isIcmBio()")
            br
            | 5. Gerar declaração de trâmite processual: disponível apenas para processos de regularização fundiária por
            | Alienação simples doação
        div(v-if="!isAmapa() && !isIcmBio()")
          p
            b Cadastros On-line:&nbsp
            | {{CENTRAL_DO_INTERESSADO.CADASTROS_ONLINE.DESCRICAO}}

          p Módulo de Cadastro On-line conta com duas ferramentas para a realização do cadastro:

          div.funcionalidades
            p 1. Cadastrar: permite ao cadastrante o preenchimento das informações necessárias para a solicitação
              |  de regularização de área de interesse e dos demais serviços acima especificados;
              br
              | 2. Enviar cadastro: permite o envio do cadastro para o Módulo Receptor.

        br
        el-button.botao(
          type="primary",
          @click="redirectToPortal"
        )
          font-awesome-icon(icon="external-link-alt", size="lg")
          span
            b.text-botao Acessar a Central do Interessado

</template>

<script>
import { mapState } from 'vuex'

export default {
  methods: {
    redirectToPortal () {
      this.$router.push({ name: 'central/home' })
    },

    redirect () {
      this.$router.push({
        name: 'documentosCadastro'
      })
    },

    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    isRondonia () {
      return process.env.ESTADO === 'ro'
    },
    isIcmBio () {
      return process.env.ESTADO === 'default'
    }
  },
  computed: {
    ...mapState({
      CENTRAL_DO_INTERESSADO: state => state.userInterface.dadosEstado.PUBLICO.CENTRAL_DO_INTERESSADO
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';
.page-content {
  color: #777373;
  p {
    line-height: 1.9em;
  }
}
.title {
  color: $--color-primary;
  margin-bottom: 0;
}

.funcionalidades {
  padding-left: 15px;
}
.botao {
  margin: 30px 0;
  display: flex;
  align-items: center;
}

.text-botao {
  margin-left: 10px;
  font-weight: 400;
}

.icone {
  margin: 0 5px;
}

.texto-aviso {
  font-size: 1em;
}
.icon-aviso {
  font-size: 1.1em !important;
}

p {
  line-height: 1.5;
  font-size: 1.2em;
}

@media (max-width: 1256px) {
  .texto-aviso {
    display: flex;
    white-space: break-spaces;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/CentralInteressado.vue